'use client';

import { create } from 'zustand';
import type { SowingCalendarViewMode } from '@modules/sowing-calendar/models';
import {
  shiftFocusedMonth,
  shiftFocusedWeek,
  toLocalISODate,
} from '@modules/sowing-calendar/business_logic';

interface SowingCalendarStore {
  viewMode: SowingCalendarViewMode;
  focusedDate: string;
  selectedMonthDay: string | null;

  setViewMode: (mode: SowingCalendarViewMode) => void;
  setSelectedMonthDay: (isoDate: string | null) => void;
  goToPrevPeriod: () => void;
  goToNextPeriod: () => void;
  goToToday: () => void;
}

export const useSowingCalendarStore = create<SowingCalendarStore>((set, get) => ({
  viewMode: 'agenda',
  focusedDate: toLocalISODate(new Date()),
  selectedMonthDay: toLocalISODate(new Date()),

  setViewMode: (mode) => set({ viewMode: mode }),

  setSelectedMonthDay: (isoDate) => set({ selectedMonthDay: isoDate }),

  goToPrevPeriod: () => {
    const { viewMode, focusedDate } = get();
    if (viewMode === 'month') {
      set({ focusedDate: shiftFocusedMonth(focusedDate, -1), selectedMonthDay: null });
      return;
    }
    if (viewMode === 'week') {
      set({ focusedDate: shiftFocusedWeek(focusedDate, -1) });
    }
  },

  goToNextPeriod: () => {
    const { viewMode, focusedDate } = get();
    if (viewMode === 'month') {
      set({ focusedDate: shiftFocusedMonth(focusedDate, 1), selectedMonthDay: null });
      return;
    }
    if (viewMode === 'week') {
      set({ focusedDate: shiftFocusedWeek(focusedDate, 1) });
    }
  },

  goToToday: () => {
    const today = toLocalISODate(new Date());
    set({ focusedDate: today, selectedMonthDay: today });
  },
}));
